module.exports = __webpack_public_path__ + "static/media/manage-equipment.b8ecf862.svg";